/* Custom kit: match Shopify variants and upload the photo with its cart item. */
(function () {
  'use strict';
  var pdp = document.querySelector('[data-mp-pdp]');
  if (!pdp) return;
  var section = pdp.closest('.shopify-section') || document;
  var form = section.querySelector('#mp-add-form');
  if (!form) return;
  var variants = JSON.parse(section.querySelector('[data-mp-variants]').textContent);
  var messages = JSON.parse(section.querySelector('[data-mp-messages]').textContent);
  var groups = Array.from(section.querySelectorAll('[data-mp-option-group]'));
  var input = form.querySelector('[data-mp-upload-input]');
  var idInput = form.querySelector('[data-mp-variant-id]');
  var add = form.querySelector('[data-mp-add]');
  var stickyAdd = section.querySelector('[data-mp-sticky-add]');
  var hint = form.querySelector('[data-mp-purchase-hint]');
  var status = form.querySelector('[data-mp-upload-status]');
  var progress = form.querySelector('[data-mp-progress]');
  var preview = form.querySelector('[data-mp-photo-preview]');
  var viewCart = form.querySelector('[data-mp-view-cart]');
  var photoReady = false, busy = false, complete = false, version = 0;
  var reader, selectedVariant, photoWarning = false, pendingUpload = null;
  var cartUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
  // Scroll to the first step still missing (photo or an option) and highlight the hint.
  function mpGo() {
    var targets = groups.filter(function (group) { return !group.querySelector('[aria-pressed="true"]'); });
    if (!photoReady) targets.push(form.querySelector('[data-mp-upload]') || input);
    targets.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
    (targets[0] || form).scrollIntoView({ behavior: 'smooth', block: 'center' });
    hint.style.color = '#c0392b';
    hint.style.fontWeight = '700';
  }
  function say(text) { status.hidden = false; status.textContent = text || messages.read_error; status.removeAttribute('data-photo-state'); }
  function resetComplete() {
    if (!complete) return;
    complete = false; viewCart.hidden = true;
    if (photoReady) say(photoWarning ? messages.photo_recommended : messages.ready);
  }
  function refresh() {
    var options = groups.map(function (group) {
      var selected = group.querySelector('[aria-pressed="true"]');
      group.querySelector('[data-mp-option-hint]').hidden = !!selected;
      return selected ? selected.dataset.mpValue : null;
    });
    selectedVariant = variants.find(function (variant) {
      return variant.options.length === options.length && variant.options.every(function (value, index) { return value === options[index]; });
    });
    idInput.value = selectedVariant ? selectedVariant.id : '';
    idInput.disabled = !selectedVariant || !selectedVariant.available;
    if (selectedVariant) section.querySelectorAll('[data-mp-price], [data-mp-sticky-price]').forEach(function (el) { el.textContent = selectedVariant.price; });
    var ready = photoReady && selectedVariant && selectedVariant.available;
    add.disabled = busy || complete;
    // Not ready yet: keep the button looking active; a click scrolls to the missing step (see mpGo).
    add.toggleAttribute('data-mp-blocked', !ready);
    if (stickyAdd) stickyAdd.disabled = add.disabled;
    var label = complete ? messages.added : messages.add_to_cart;
    add.textContent = label;
    if (stickyAdd) stickyAdd.textContent = label;
    hint.textContent = complete ? messages.complete : (options.every(Boolean) && (!selectedVariant || !selectedVariant.available) ? messages.unavailable : (ready ? '' : messages.missing));
  }
  groups.forEach(function (group) {
    group.querySelectorAll('[data-mp-option-position]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (busy) return;
        resetComplete();
        group.querySelectorAll('[data-mp-option-position]').forEach(function (sibling) { sibling.setAttribute('aria-pressed', String(sibling === button)); });
        refresh();
      });
    });
  });
  var lastPhoto = null, readTimer = null, photoUrl = null, pickerTimer = null;
  var urlApi = window.URL || window.webkitURL;
  function stopPhotoRead() {
    clearTimeout(readTimer);
    if (reader && reader.readyState === 1) reader.abort();
    if (photoUrl && urlApi) { urlApi.revokeObjectURL(photoUrl); photoUrl = null; }
  }
  function inspectPhoto(force) {
    if (busy) return;
    var file = input.files && input.files[0];
    if (!force && file === lastPhoto) return;
    lastPhoto = file;
    var token = ++version;
    stopPhotoRead();
    resetComplete(); photoReady = false; photoWarning = false;
    form.querySelector('[data-mp-upload-verdict]').value = '';
    preview.hidden = true; preview.removeAttribute('src'); progress.hidden = true;
    var filename = form.querySelector('[data-mp-upload-name]');
    filename.hidden = !file; filename.textContent = file ? file.name : '';
    say(messages.reading);
    refresh();
    function rejectPhoto(message) {
      if (token !== version) return;
      ++version;
      stopPhotoRead();
      photoReady = false; progress.hidden = true;
      say(message); status.setAttribute('data-photo-state', 'error'); refresh();
    }
    if (!file) { say(messages.choose_photo); return; }
    var allowedType = /^image\/(jpeg|png|webp)$/i.test(file.type);
    var unknownType = !file.type || file.type === 'application/octet-stream';
    if ((!allowedType && !(unknownType && /\.(jpe?g|png|webp)$/i.test(file.name))) || !file.size) { rejectPhoto(messages.invalid_photo); return; }
    if (file.size > 10000000) { rejectPhoto(messages.photo_too_large); return; }
    progress.hidden = false; progress.removeAttribute('value');
    readTimer = setTimeout(function () { rejectPhoto(messages.read_error); }, 20000);
    function decodePhoto(source) {
      try {
        var image = new Image();
        image.onerror = function () { rejectPhoto(messages.read_error); };
        image.onload = function () {
          if (token !== version) return;
          try {
            var shortSide = Math.min(image.naturalWidth, image.naturalHeight);
            var longSide = Math.max(image.naturalWidth, image.naturalHeight);
            if (shortSide < 900 || longSide < 1200) { rejectPhoto(messages.photo_too_small); return; }
            clearTimeout(readTimer);
            photoWarning = shortSide < 1500 || longSide < 2000;
            preview.src = source; preview.hidden = false; progress.hidden = true; photoReady = true;
            form.querySelector('[data-mp-upload-verdict]').value = image.naturalWidth + ' x ' + image.naturalHeight + ' px; manual review required';
            say(photoWarning ? messages.photo_recommended : messages.ready);
            status.setAttribute('data-photo-state', photoWarning ? 'warning' : 'ready'); refresh();
          } catch (error) { rejectPhoto(messages.read_error); }
        };
        image.src = source;
      } catch (error) { rejectPhoto(messages.read_error); }
    }
    try {
      if (urlApi && urlApi.createObjectURL) {
        photoUrl = urlApi.createObjectURL(file); decodePhoto(photoUrl);
      } else {
        reader = new FileReader();
        reader.onerror = function () { rejectPhoto(messages.read_error); };
        reader.onload = function (event) { if (token === version) decodePhoto(event.target.result); };
        reader.readAsDataURL(file);
      }
    } catch (error) { rejectPhoto(messages.read_error); }
  }
  input.addEventListener('input', function () { inspectPhoto(false); });
  input.addEventListener('change', function () { inspectPhoto(false); });
  input.addEventListener('cancel', function () { inspectPhoto(true); });
  input.addEventListener('click', function () {
    if (busy) return;
    if (!photoReady) say(messages.choose_photo);
    clearInterval(pickerTimer);
    var ticks = 0;
    pickerTimer = setInterval(function () {
      inspectPhoto(false);
      if (++ticks >= 120) clearInterval(pickerTimer);
    }, 500);
  });
  window.addEventListener('focus', function () { setTimeout(function () { inspectPhoto(false); }, 300); });
  window.addEventListener('pageshow', function () { inspectPhoto(false); });
  if (stickyAdd) stickyAdd.addEventListener('click', function (event) {
    event.preventDefault();
    if (add.hasAttribute('data-mp-blocked')) mpGo();
    else if (!add.disabled) form.requestSubmit(add);
  });
  // Main button: when a step is missing, skip native validation and scroll to that step instead.
  add.addEventListener('click', function (event) {
    if (add.hasAttribute('data-mp-blocked')) { event.preventDefault(); mpGo(); }
  });
  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (busy || complete) return;
    refresh();
    if (add.disabled) return;
    if (add.hasAttribute('data-mp-blocked')) { mpGo(); return; }
    if (!form.reportValidity()) return;
    if (pendingUpload) {
      busy = true; refresh(); say(messages.checking_cart);
      try {
        var response = await fetch(cartUrl + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('cart');
        var checkedCart = await response.json();
        if (!Array.isArray(checkedCart.items)) throw new Error('cart');
        var existing = checkedCart.items.find(function (item) { return item.properties && item.properties._upload_id === pendingUpload; });
        pendingUpload = null;
        busy = false;
        if (existing) {
          complete = true; refresh(); say(messages.complete); viewCart.hidden = false; viewCart.focus(); return;
        }
        refresh();
        if (add.disabled || add.hasAttribute('data-mp-blocked')) return;
      } catch (error) {
        busy = false; refresh(); say(messages.check_failed); viewCart.hidden = false; return;
      }
    }
    // One snapshot keeps the selected photo and variant together during upload.
    var data = new FormData(form);
    data.set('id', selectedVariant.id); data.set('quantity', '1');
    pendingUpload = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    data.set('properties[_upload_id]', pendingUpload);
    var expectedId = String(selectedVariant.id);
    busy = true; refresh(); input.disabled = true;
    groups.forEach(function (group) { group.querySelectorAll('button').forEach(function (button) { button.disabled = true; }); });
    progress.hidden = false; progress.value = 0; say(messages.uploading + ' 0%');
    var xhr = new XMLHttpRequest();
    xhr.open('POST', cartUrl + '/add.js');
    xhr.setRequestHeader('Accept', 'application/json'); xhr.timeout = 180000;
    xhr.upload.onprogress = function (upload) {
      if (!upload.lengthComputable) return;
      var percent = Math.round(upload.loaded / upload.total * 100);
      progress.value = percent;
      say(percent === 100 ? messages.processing : messages.uploading + ' ' + percent + '%');
    };
    function unlock() {
      busy = false; input.disabled = false;
      groups.forEach(function (group) { group.querySelectorAll('button').forEach(function (button) { button.disabled = false; }); });
      refresh();
    }
    function fail(message) { unlock(); say(message || messages.add_error); viewCart.hidden = false; }
    xhr.onerror = xhr.ontimeout = function () { fail(); };
    xhr.onload = function () {
      var result;
      try { result = JSON.parse(xhr.responseText); } catch (_) { fail(); return; }
      if (xhr.status < 200 || xhr.status >= 300) { fail(typeof result.description === 'string' ? result.description : messages.add_error); return; }
      var item = result.items ? result.items[0] : result;
      if (String(item.variant_id || item.id) !== expectedId || !item.properties || !item.properties['Customer photo']) { fail(); return; }
      pendingUpload = null; complete = true; unlock(); progress.value = 100; say(messages.complete);
      viewCart.hidden = false; viewCart.focus();
      fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mp-product', cartData: cart });
        }).catch(function () { /* The cart link opens authoritative server totals. */ });
    };
    xhr.send(data);
  });
  document.querySelectorAll('[data-mp-modal-open]').forEach(function (button) {
    button.addEventListener('click', function () { var dialog = document.getElementById(button.dataset.mpModalOpen); if (dialog) dialog.showModal(); });
  });
  document.querySelectorAll('[data-mp-modal-close]').forEach(function (button) {
    button.addEventListener('click', function () { button.closest('dialog').close(); });
  });
  var sticky = section.querySelector('[data-mp-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    // Show the sticky bar only after the price has scrolled out of view and the main button is off-screen,
    // so it never covers the price on first load (mobile).
    var mpPrice = section.querySelector('[data-mp-price]');
    var mpAddVisible = true, mpPricePassed = !mpPrice;
    var mpSticky = function () { sticky.classList.toggle('is-on', !mpAddVisible && mpPricePassed); };
    new IntersectionObserver(function (entries) { mpAddVisible = entries[0].isIntersecting; mpSticky(); }, { rootMargin: '0px 0px -80px 0px' }).observe(add);
    if (mpPrice) new IntersectionObserver(function (entries) { mpPricePassed = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0; mpSticky(); }).observe(mpPrice);
  }
  refresh();
})();
